import * as yup from 'yup'
import { yupResolver } from '@hookform/resolvers/yup'

export const returnPreviewModalSchema = yupResolver(
  yup.object({
    accounts: yup
      .array()
      .of(
        yup.object({
          account: yup.string().required('Conta é obrigatória'),
          returnJustification: yup.string().required('Justificativa da devolução é obrigatória'),
          draftItemId: yup.string().optional()
        })
      )
      .min(1, 'Adicione pelo menos uma conta para devolver')
  })
)
